import { IApiClient } from "@common/network/interfaces";
import { ApiClient } from "@network/client";
import { getConfig } from "@config/index";
import { ISubscriptionAccountWithCallback } from "@common/redux/subscription/interface";

const ENDPOINTS = {
  fetchCatalogue: () => `/api/catalog`,
  // checkSubscription: () => `/api/accounts`,
  // createAccount: () => `/api/accounts`,
  // updateAccount: () => `/api/accounts`,
  createSubscription: () => `/api/subscription`,
  createPaymentSession: () => `/api/payments`,
  // updatePaymentMethod: () => `/api/accounts/`,
  fetchAllInvoices: (accountId: string, productName: string) =>
    `/api/accounts/${accountId}/invoices?productName=${productName}`,
  fetchInvoiceById: (invoiceId: string) => `/api/invoices/${invoiceId}`,
  fetchInvoicePayments: (accountId: string) =>
    `/api/accounts/${accountId}/invoicePayments`,
  fetchPaymentIntent: (accountId: string) =>
    `/api/accounts/${accountId}/paymentIntent`,
  updatePaymentStatus: (paymentId) => `/api/payments/${paymentId}`,
  fetchUserLocation: () => `api/form-service/public/subscription/getGeoLocationDetails`,
  getUserAccountDetails: (accountId) => `/api/accounts/${accountId}/bundles`,
  
  fetchUserSubscriptions: (userId: string, productName: string) =>
    `api/payment-service/subscriptions/user/${userId}/product/${productName}`,
  fetchSubscriptionInvoices: (subscriptionId: string, userId: string,) =>
    `api/payment-service/subscriptions/${subscriptionId}/user/${userId}/invoices`,

  fetchPaymentStatus: (subscriptionId: string) =>
    `api/payment-service/subscriptions/${subscriptionId}/with-payment-status`,
};

class SubscriptionRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  public fetchCatalogue = async (productName: string) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchCatalogue(),
      { productName: productName },
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };

  // public getSubscriptionAccount = async (payload: { externalKey: string }) => {
  //   if (!payload.externalKey && payload.externalKey == "") return;
  //   const params = {
  //     externalKey: payload.externalKey,
  //   };
  //   const result = await this.apiClient.get(
  //     ENDPOINTS.checkSubscription(),
  //     params,
  //     {
  //       baseURL: getConfig().KILLBILL_BASE_URL,
  //     }
  //   );
  //   return result.data;
  // };

  // public createAccount = async (payload: { data: any }) => {
  //   const result = await this.apiClient.post(
  //     ENDPOINTS.createAccount(),
  //     payload.data,
  //     {
  //       pluginProperty: "",
  //     },
  //     {
  //       baseURL: getConfig().KILLBILL_BASE_URL,
  //     }
  //   );
  //   return result.data;
  // };

  // public updateAccount = async (payload: ISubscriptionAccountWithCallback) => {
  //   // const params = { externalKey: payload.externalKey,  };
  //   const result = await this.apiClient.put(
  //     `${ENDPOINTS.updateAccount()}/${payload.accountId}`,
  //     payload,
  //     {},
  //     {
  //       baseURL: getConfig().KILLBILL_BASE_URL,
  //     }
  //   );
  //   return result.data;
  // };
  public createSubscription = async (payload: {
    accountId: string;
    planName: string;
    pluginProperty?: string;
    phaseType?: string;
    applicationId?: string;
    productName?: string;
  }) => {
    const payloadData = {
      pluginProperty: payload.pluginProperty,
      phaseType: payload.phaseType,
      accountId: payload.accountId,
      planName: payload.planName,
      applicationId: payload.applicationId,
    };
    const baseUrl = getConfig().KILLBILL_BASE_URL;

    const result = await this.apiClient.post(
      ENDPOINTS.createSubscription(),
      { ...payloadData },
      {
        callCompletion: true,
        callTimeoutSec: 200000,
        pluginProperty: payload.pluginProperty,
        applicationId: payload.applicationId,
        productName: payload.productName,
      },
      {
        baseURL: baseUrl,
      }
    );
    return result.data;
  };
  public createPaymentSession = async (params: {
    kbAccountId: string;
    successUrl: string;
    cancelUrl: string;
  }) => {
    const userAccountId = "";
    const planName = "";
    const amount = "";
    const billingPeriod = "";
    const paymentMethod = "";
    const beneficiaryName = "";
    const accountNumber = "";
    const accountType = "";
    const ifscCode = "";
    const successUrl = encodeURIComponent(
      ""
    );
    const cancelUrl = encodeURIComponent(
      ""
    );

    const paramsValues = {
      kbAccountId: userAccountId,
      planName: planName,
      amount: amount,
      billingPeriod: billingPeriod,
      paymentMethod: paymentMethod,
      beneficiaryName: encodeURIComponent(beneficiaryName),
      accountNumber: accountNumber,
      accountType: accountType,
      ifscCode: ifscCode,
      successUrl: successUrl,
      cancelUrl: cancelUrl,
    };
    const result = await this.apiClient.post(
      ENDPOINTS.createPaymentSession(),
      {},
      paramsValues,
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };
  // public updatePaymentMethod = async (params: {
  //   accountId: string;
  //   sessionId: string;
  // }) => {
  //   const updatedPaymentUrl = `${ENDPOINTS.updatePaymentMethod()}${
  //     params.accountId
  //   }/paymentMethods`;
  //   const result = await this.apiClient.post(
  //     updatedPaymentUrl,
  //     {
  //       accountId: params.accountId,
  //       isDefault: true,
  //       pluginName: "killbill-stripe",
  //       pluginInfo: {
  //         isDefaultPaymentMethod: true,
  //         properties: [
  //           {
  //             key: "sessionId",
  //             value: params.sessionId,
  //             isUpdatable: true,
  //           },
  //         ],
  //       },
  //     },
  //     { pluginProperty: `sessionId=${params.sessionId}` },
  //     {
  //       baseURL: getConfig().KILLBILL_BASE_URL,
  //     }
  //   );
  //   return result.data;
  // };
  public getAllInvoices = async (params: {
    accountId: string;
    productName: string;
  }) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchAllInvoices(params.accountId, params.productName),
      {},
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };
  public getInvoiceById = async (params: { invoiceId: string }) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchInvoiceById(params.invoiceId),
      {
        invoiceId: params.invoiceId,
      },
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };
  public fetchInvoicePayments = async (params: { accountId: string }) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchInvoicePayments(params.accountId),
      {
        accountId: params.accountId,
      },
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };
  public fetchPaymentIntent = async (params: { accountId: string }) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchPaymentIntent(params.accountId),
      {
        accountId: params.accountId,
      },
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };

  public updatePaymentStatus = async (params: { paymentId: string }) => {
    const result = await this.apiClient.put(
      ENDPOINTS.updatePaymentStatus(params.paymentId),
      {},
      {},
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };
  public getUserLocation = async () => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchUserLocation(),
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public getUserAccountDetails = async (params: { accountId: string }) => {
    const result = await this.apiClient.get(
      ENDPOINTS.getUserAccountDetails(params.accountId),
      { audit: "NONE" },
      {
        baseURL: getConfig().KILLBILL_BASE_URL,
      }
    );
    return result.data;
  };

  
  public fetchUserSubscriptions = async (params: { userId: string; productName: string }) => {
    try {
      const result = await this.apiClient.get(
        ENDPOINTS.fetchUserSubscriptions(params.userId, params.productName),
        {},
        {
          baseURL: getConfig().APP_BE_BASE_URL,
        }
      );
      if (!result.data) {
        throw new Error('Invalid API response: No data received');
      }
      return result.data;
    } catch (error) {
      console.error('Error in fetchUserSubscriptions:', error);
      throw error;
    }
  };


  public fetchUserSubscriptionStatus = async (params: { userId: string; productName: string; status: string }) => {
    try {
      const url = `${ENDPOINTS.fetchUserSubscriptions(params.userId, params.productName)}/status/${params.status}`;
      const result = await this.apiClient.get(
        url,
        {}, 
        {
          baseURL: getConfig().APP_BE_BASE_URL,
        }
      );
      if (!result.data) {
        throw new Error('Invalid API response: No data received');
      }
      return result.data;
    } catch (error) {
      console.error('Error in fetchUserSubscriptionStatus:', error);
      throw error;
    }
  };


  public fetchSubscriptionInvoices = async (params: { subscriptionId: string; userId: string }) => {
    try {
      const result = await this.apiClient.get(
        ENDPOINTS.fetchSubscriptionInvoices(params.subscriptionId, params.userId),
        {},
        {
          baseURL: getConfig().APP_BE_BASE_URL,
        }
      );
      if (!result.data) {
        throw new Error('Invalid API response: No data received');
      }
      return result.data;
    } catch (error) {
      console.error('Error in fetchUserSubscriptions:', error);
      throw error;
    }
  };

  public fetchPaymentStatus = async (params: { subscriptionId: string; }) => {
    try {
      const result = await this.apiClient.get(
        ENDPOINTS.fetchPaymentStatus(params.subscriptionId),
        {},
        {
          baseURL: getConfig().APP_BE_BASE_URL,
        }
      );
      if (!result.data) {
        throw new Error('Invalid API response: No data received');
      }
      return result.data;
    } catch (error) {
      console.error('Error in fetchUserSubscriptions:', error);
      throw error;
    }
  };
}

const subscriptionRepository = new SubscriptionRepository(ApiClient);

export { subscriptionRepository as SubscriptionRepository };
